import { LogLevel } from '../logger/log-levels.enum';

const logLevelValuesMap: { [key: string]: 'info' | 'debug' | 'warn' | 'error' } = {
  [LogLevel.Info]: 'info',
  [LogLevel.Debug]: 'debug',
  [LogLevel.Warn]: 'warn',
  [LogLevel.Error]: 'error',
};

Object.freeze(logLevelValuesMap);
export { logLevelValuesMap };
